import * as Sentry from "@sentry/react";

import { CONFIG } from "@/shared/model/config";

export function initSentry() {
  if (!CONFIG.SENTRY_DSN) return;

  Sentry.init({
    dsn: CONFIG.SENTRY_DSN,
    environment: CONFIG.SENTRY_ENVIRONMENT,
    release: CONFIG.SENTRY_RELEASE,

    tracesSampleRate: CONFIG.SENTRY_TRACES_SAMPLE_RATE,

    // Propagate sentry-trace/baggage headers to API for distributed tracing
    tracePropagationTargets: [window.location.origin],

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: true,
        maskAllText: false,
      }),
    ],

    // Session replay: capture all sessions
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,

    sendDefaultPii: true,

    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
        // Strip auth headers from breadcrumb data
        delete breadcrumb.data?.["access-token"];
        delete breadcrumb.data?.client;
      }
      return breadcrumb;
    },
  });
}
